import { ReactNode, useEffect, useMemo } from "react";
import { Box, HStack, Progress, Stack, Text } from "@chakra-ui/react";

import { MainPageModal } from "../Modal";
import { useAppModal } from "../../Modals";
import { useGetLimitQuery } from "../../../../api/limit";
import { SessionStorageKeys } from "../../../../constants";
import { formatPrice, isStringWithNumber } from "../../../../utils";

export function MainPageAvailableLimit(): ReactNode {
  const { showModal } = useAppModal();
  const { data } = useGetLimitQuery();

  const showStatus = data?.status === "CLOSED" || data?.status === "BLOCKED";
  const statusText = data?.status === "BLOCKED" ? "Заблокирован" : "Закрыт";
  const statusTextVariant = data?.status === "BLOCKED" ? "red" : "gray";

  const availableAmount = isStringWithNumber(data?.balance) ? formatPrice(Number(data?.balance), 0) : "";
  const totalAmount = isStringWithNumber(data?.amount) ? formatPrice(Number(data?.amount), 0) : "";
  const spentAmount = isStringWithNumber(data?.amount) && Number(data?.amount) > 0 && availableAmount
    ? formatPrice(Number(data?.amount) - Number(data?.balance), 0)
    : "";

  const percentageLeft = useMemo(() => {
    const total = isStringWithNumber(data?.amount) ? Number(data?.amount) : 0;
    const available = isStringWithNumber(data?.balance) ? Number(data?.balance) : 0;

    if (total <= 0) {
      return 0;
    }

    const percent = (available / total) * 100;
    return Math.min(Math.max(percent, 0), 100);
  }, [data?.amount, data?.balance]);

  useEffect(() => {
    const STORAGE_KEY = SessionStorageKeys.blockedLimitModalShown;

    if (data?.status === "BLOCKED" && sessionStorage.getItem(STORAGE_KEY) !== "true") {
      sessionStorage.setItem(STORAGE_KEY, "true");

      showModal({
        content: onClose => <MainPageModal message="Лимит заблокирован" onClose={onClose} />,
      });
    }

    if (data?.status && data.status !== "BLOCKED") {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [data]);

  return (
    <Box bg="white" borderRadius="16px" p="20px" w="100%">
      <Stack spacing={0}>
        <HStack h="26px" alignItems="center" mb="10px">
          <Text>Доступный лимит</Text>
        </HStack>

        <HStack h="26px" justifyContent="space-between" mb={2}>
          <Text variant="brand" fontFamily="Normalidad Medium Var" fontSize="22px" pb={1}>
            {availableAmount}
          </Text>

          {showStatus && <Text fontSize="12px" variant={statusTextVariant}>{statusText}</Text>}
        </HStack>

        <Stack h="20px" justifyContent="center" mb="2px">
          <Progress
            h="2px"
            value={percentageLeft}
            colorScheme="purple"
            overflow="visible"
            sx={{
              "& > div": {
                height: "8px",
                marginTop: "-3px",
                borderRadius: "35px",
              },
            }}
          />
        </Stack>

        {spentAmount && (
          <Text h="18px" fontSize="12.5px">
            {`Использовано ${spentAmount} из ${totalAmount}`}
          </Text>
        )}
      </Stack>
    </Box>
  );
}
